'use strict';

var AttachmentsCtrl = function ($scope, office, gettextCatalog, Notification, OfficeDA, ModalService) {
  this._ModalService = ModalService;
  this._OfficeDA = OfficeDA;
  this._Notification = Notification;
  this.office = office;
  this.gettextCatalog = gettextCatalog;
  this.showPremiumNotification = !$scope.subscription.empty && !['plus', 'enterprise'].includes($scope.subscription.package);
};

AttachmentsCtrl.prototype.add = function () {
  this._ModalService.openAttachmentModal(null, (response) => {
    if (response !== 'abort') {
      this.office = response;
    }
  });
};

AttachmentsCtrl.prototype.edit = function (attachment) {
  this._ModalService.openAttachmentModal(attachment, (response) => {
    if (response !== 'abort') {
      this.office = response;
    }
  });
};

AttachmentsCtrl.prototype.delete = async function (attachment) {
  try {
    const updatedOffice = await this._OfficeDA.deleteAttachment(attachment._id);
    this._Notification.addSuccessMessage(this.gettextCatalog.getString('Attachment deleted'));
    this.office = updatedOffice;
  } catch (e) {
    this._Notification.addErrorMessage(this.gettextCatalog.getString('Unknown Error! Currently not possible to delete this attachment.'));
  }
};

module.exports = AttachmentsCtrl;
